module.exports = __webpack_public_path__ + "img/cricket.4175220.webp";